import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-submission-bar',
  templateUrl: './submission-bar.component.html',
  styleUrls: ['./submission-bar.component.scss'],
  standalone: false,
})
export class SubmissionBarComponent {
  @Input() backButtonText: string;
  @Input() clearButtonText: string;
  @Input() submitButtonText: string;

  @Input() backButtonDisabled = false;
  @Input() clearkButtonDisabled = false;
  @Input() submitButtonDisabled = false;

  @Output() back = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();
  @Output() submit = new EventEmitter<any>();

  backAction() {
    this.back.emit();
  }

  clearAction() {
    this.clear.emit();
  }

  submitAction() {
    this.submit.emit();
  }
}
